;
// Handles showing and hiding of dependant questions on the custom questions forms.
(function() {
  var snCustomQuestionsModule = function () {
    var self = this;

    return {
      init: function() {
        self = this;
        $('[data-depends-on-question]').each(function(i, dependsOnQuestionEl) {
          var $dependsOnQuestionEl = $(dependsOnQuestionEl);
          self._initDependsOnQuestion($dependsOnQuestionEl);
        });
      },

      _initDependsOnQuestion: function($dependsOnQuestionEl) {
        var dependsOnData = self._readDependsOnData($dependsOnQuestionEl);
        if (dependsOnData.dependsOnQuestion) {
          var sourceQuestion = self._readSourceQuestion(dependsOnData.dependsOnQuestion);
          var $sourceQuestion = $(sourceQuestion.selector);
          if (sourceQuestion.length > 0) {
            switch (sourceQuestion.questionType) {
              case 'list':
                if (self._isSelect($sourceQuestion)) {
                  self._setupSelectToggle($dependsOnQuestionEl, dependsOnData.dependsOnAnswer, $sourceQuestion);
                } else {
                  self._setupRadioToggle($dependsOnQuestionEl, dependsOnData.dependsOnAnswer, $sourceQuestion);
                }
                break;
              case 'multiple':
                self._setupCheckboxToggle($dependsOnQuestionEl, dependsOnData.dependsOnAnswer, $sourceQuestion);
            }
          }
        }
      },

      _shouldDisplayDependantQuestion: function(dependsOnAnswer, answers) {
        var answerFound = false;
        answers.forEach(function(answer) {
          if (dependsOnAnswer.indexOf(answer) >= 0) {
            answerFound = true;
          }
        });
        return answerFound;
      },

      _setupToggle: function($dependsOnQuestionEl, dependsOnAnswer, $sourceQuestion, $sourceInputEl, getAnswerValues) {
        $sourceQuestion.change(function() {
          var answers = getAnswerValues($sourceInputEl);
          if (self._shouldDisplayDependantQuestion(dependsOnAnswer, answers)) {
            $dependsOnQuestionEl.show();
          } else {
            $dependsOnQuestionEl.hide();
          }
        }).change();
      },

      _setupSelectToggle: function($dependsOnQuestionEl, dependsOnAnswer, $sourceQuestion) {
        var $sourceInputEl = $('select', $sourceQuestion);
        var getAnswerValues = function($sourceInputEl) {
          return [$sourceInputEl.val()];
        }
        self._setupToggle($dependsOnQuestionEl, dependsOnAnswer, $sourceQuestion, $sourceInputEl, getAnswerValues);
      },

      _setupRadioToggle: function($dependsOnQuestionEl, dependsOnAnswer, $sourceQuestion) {
        var $sourceInputEl = $('[type="radio"]', $sourceQuestion);
        var getAnswerValues = function($sourceInputEl) {
          return [$sourceInputEl.filter(':checked').val()];
        }
        self._setupToggle($dependsOnQuestionEl, dependsOnAnswer, $sourceQuestion, $sourceInputEl, getAnswerValues);
      },

      _setupCheckboxToggle: function($dependsOnQuestionEl, dependsOnAnswer, $sourceQuestion) {
        var $sourceInputEl = $('[type="checkbox"]', $sourceQuestion);
        var getAnswerValues = function($sourceInputEl) {
          return $sourceInputEl.filter(':checked').map(function() {
            return $(this).val();
          }).toArray();
        }
        self._setupToggle($dependsOnQuestionEl, dependsOnAnswer, $sourceQuestion, $sourceInputEl, getAnswerValues);
      },

      _isSelect: function($sourceQuestion) {
          var $list = $('select', $sourceQuestion);
          return $list.length > 0;
      },

      _parseDependsOnAnswer: function(data) {
        // Test this
        return data.split(',')
          .map(function(item) { return item.trim(); })
          .filter(function(item) { return item != ""; });
      },

      _readDependsOnData: function(el) {
        var $el = $(el);
        var dependsOnQuestion = $el.data('dependsOnQuestion');
        var dependsOnAnswer = self._parseDependsOnAnswer($el.data('dependsOnAnswer'));
        return {
          dependsOnQuestion: dependsOnQuestion,
          dependsOnAnswer: dependsOnAnswer
        };
      },

      _readSourceQuestion: function(dependsOnQuestion) {
        var sourceQuestionSelector = '[data-question-id=' + dependsOnQuestion + ']';
        $sourceQuestion = $(sourceQuestionSelector);
        return {
          selector: sourceQuestionSelector,
          length: $sourceQuestion.length,
          questionType: $sourceQuestion.data('questionType')
        };
      }

    }
  }();

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = snCustomQuestionsModule;
  } else {
    window.snCustomQuestionsModule = snCustomQuestionsModule;
  }

})();